import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const DBNDomainBasicInfoComponent = ({
    handleInnerFormChange, selectedDBNDomain, domains
}: any) => {
    console.log('selectedDBNDomain', selectedDBNDomain)
    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Name"
                            isDisabled={true}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                )
                            }}
                            type="text"
                            value={selectedDBNDomain?.Name}
                        />
                        <InputContainer
                            label="Is Subdomain"
                            name="IsSubDomain"
                            isDisabled={true}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsSubDomain'
                                )                                
                            }}
                            type="checkbox"
                            value={selectedDBNDomain?.IsSubDomain}
                            />
                        {selectedDBNDomain?.IsSubDomain && <InputContainer
                            label="Parent Domain"
                            labelField="Name"
                            isDisabled={true}
                            list={domains}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ParentDomainId'
                                );
                            }}
                            optionName='Choose Parent Domain'
                            type="select"
                            value={selectedDBNDomain?.ParentDomainId}
                            valueField="EdgeDBNDomainId"
                        />}

                        <InputContainer
                            label="Code"
                            isDisabled={true}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                )
                            }}
                            type="text"
                            value={selectedDBNDomain?.Code}
                        />
                    </div>
                }
                expandedPanel="basicInfo"
                headerTitle="Domain Information"
            />
        </>
    )
}

export default DBNDomainBasicInfoComponent;
